import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DeleteAccountModalComponent } from './delete-account-modal.component';
import { DeactivateOrDeleteAccountSharedModule } from '../deactivate-or-delete-account-shared/deactivate-or-delete-account-shared.module';

@NgModule({
  imports: [
    CommonModule,
    DeactivateOrDeleteAccountSharedModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [DeleteAccountModalComponent],
  exports: [DeleteAccountModalComponent],
})
export class DeleteAccountModalModule {}
